import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';

function NotesModal({ target, text, setText, onClose, onSave }) {
  if (!target) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>{target.label || 'Notes'}</h3>
        <div className="form-group">
          <label>Notes</label>
          <textarea
            rows={5}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Add notes"
          />
        </div>
        <div className="modal-actions">
          <button type="button" onClick={onClose}>
            <X className="btn-icon" size={16} />
            <span>Cancel</span>
          </button>
          <button type="button" className="btn-primary" onClick={onSave}>
            <CheckCircle2 className="btn-icon" size={16} />
            <span>Save Notes</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotesModal;
